// Lightweight analytics dispatcher — POSTs every event to /api/events.
// PostHog is also wired from index.html and receives the same events as a
// belt-and-suspenders parallel channel; both are optional.
import api from "./api";
import storage from "./storage";

export const EVENTS = {
  APP_OPENED: "app_opened",
  ONBOARDING_COMPLETED: "onboarding_completed",
  PRODUCT_SCANNED: "product_scanned",
  REACTION_LOGGED: "reaction_logged",
  INSIGHT_VIEWED: "insight_viewed",
  PAYWALL_SEEN: "paywall_seen",
  SUBSCRIPTION_STARTED_LEMONSQUEEZY: "subscription_started_lemonsqueezy",
  SHARE_CARD_CREATED: "share_card_created",
  PHOTO_SCAN_USED: "photo_scan_used",
  MANUAL_ENTRY_USED: "manual_entry_used",
  NOTIFICATION_PERMISSION_GRANTED: "notification_permission_granted",
  NOTIFICATION_PERMISSION_DENIED: "notification_permission_denied",
  NOTIFICATION_CLICKED: "notification_clicked",
};

// Best-effort fire-and-forget — never throws.
export function track(name, props) {
  try {
    const userId = storage.getEffectiveUserId();
    api.req("POST", "/events", { user_id: userId, name, props: props || null })
      .catch(() => {});
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(name, props || {});
    }
  } catch (_) {
    // Swallow — analytics must NEVER break the user flow.
  }
}

export default { track, EVENTS };
